import axios from 'axios'
import Config from 'Configuration'

export default () => {
    return axios.create({
        baseURL: Config.webrtcGuardApiURL,
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json"
        }
    });
};